<template>
  <div class="mt-1 mb-3">
    <h3 class="mb-1 text-lg font-bold">
      {{ $t("settings.cash-drawer-and-receipts") }}
    </h3>
    <!-- Hidden where auto-print is forced (Belgium): there is nothing to choose -->
    <div v-if="!isAutoPrintReceiptForced" class="flex h-[50px] items-center">
      <p class="w-1/3 text-base">{{ $t("completeorder.print-receipt") }}</p>
      <div class="flex w-1/3 items-center gap-2">
        <SButton
          type="button"
          class="flex-1"
          :variant="autoPrintReceipt ? 'default' : 'outline'"
          @click="toggleAutoPrintReceipt(true)"
        >
          {{ $t("button.auto") }}
        </SButton>
        <SButton
          type="button"
          class="flex-1"
          :variant="autoPrintReceipt ? 'outline' : 'default'"
          @click="toggleAutoPrintReceipt(false)"
        >
          {{ $t("button.manual") }}
        </SButton>
      </div>
    </div>
    <div class="flex h-[50px] items-center">
      <p class="w-1/3 text-base">{{ $t("button.open-drawer") }}</p>
      <div class="w-1/3">
        <SSelect v-model="selectedOption">
          <SSelectTrigger class="w-full">
            <SSelectValue :placeholder="$t('button.open-drawer')" />
          </SSelectTrigger>
          <SSelectContent>
            <SSelectItem
              v-for="option in optionsArray"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </SSelectItem>
          </SSelectContent>
        </SSelect>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import POSConfigModule from "@/store/modules/pos-config";
import { OpenCashDrawerOptions } from "@/interfaces/cash-drawer";
import { useI18n } from "vue-i18n";
import PrinterConfigModule from "@/store/modules/printers-config";
import {
  SButton,
  SSelect,
  SSelectContent,
  SSelectItem,
  SSelectTrigger,
  SSelectValue,
} from "@smeetz/ui-core";

export default defineComponent({
  name: "CashDrawerSettings",
  components: {
    SButton,
    SSelect,
    SSelectContent,
    SSelectItem,
    SSelectTrigger,
    SSelectValue,
  },
  setup() {
    const { t } = useI18n({});

    const selectedOption = ref<OpenCashDrawerOptions>(
      POSConfigModule.openCashDrawer
    );
    const autoPrintReceipt = ref<boolean>(PrinterConfigModule.autoPrintReceipt);
    const isAutoPrintReceiptForced =
      PrinterConfigModule.isAutoPrintReceiptForced;

    const optionsArray: { label: string; value: OpenCashDrawerOptions }[] = [
      {
        label: t("select.after-cash-payment"),
        value: OpenCashDrawerOptions.AFTER_CASH_PAYMENT,
      },
      {
        label: t("select.after-every-sale"),
        value: OpenCashDrawerOptions.AFTER_EVERY_SALE,
      },
      {
        label: t("select.never-open"),
        value: OpenCashDrawerOptions.NEVER,
      },
    ];

    function toggleAutoPrintReceipt(status: boolean) {
      autoPrintReceipt.value = status;
    }
    return {
      selectedOption,
      optionsArray,
      autoPrintReceipt,
      isAutoPrintReceiptForced,
      toggleAutoPrintReceipt,
    };
  },
});
</script>
